export const BE_LETTERS = [
  [
    {
      name: 'Й',
    },
    {
      name: 'У',
    },
    {
      name: 'К',
    },
    {
      name: 'Е',
    },
    {
      name: 'Н',
    },
    {
      name: 'Г',
    },
    {
      name: 'Ш',
    },
    {
      name: 'Ў',
    },
    {
      name: 'З',
    },
    {
      name: 'Х',
    },
  ],
  [
    {
      name: 'Ф',
    },
    {
      name: 'Ы',
    },
    {
      name: 'В',
    },
    {
      name: 'А',
    },
    {
      name: 'П',
    },
    {
      name: 'Р',
    },
    {
      name: 'О',
    },
    {
      name: 'Л',
    },
    {
      name: 'Д',
    },
    {
      name: 'Ж',
    },
    {
      name: 'Э',
    },
  ],
  [
    {
      name: 'Я',
    },
    {
      name: 'Ч',
    },
    {
      name: 'С',
    },
    {
      name: 'М',
    },
    {
      name: 'І',
    },
    {
      name: 'Т',
    },
    {
      name: 'Ь',
    },
    {
      name: 'Б',
    },
    {
      name: 'Ю',
    },
  ],
];
